


// import React, { useEffect, useState } from 'react';
// import { Download, Smartphone, X, ShieldCheck, Zap, Sparkles } from 'lucide-react';
// // import './Downloadbutton.css';

// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false);
//   const [promptInstall, setPromptInstall] = useState(null);
//   const [isDismissed, setIsDismissed] = useState(false);

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       console.log('PWA prompt triggered');
//       setSupportsPWA(true);
//       setPromptInstall(e);
//     };

//     window.addEventListener('beforeinstallprompt', handler);

//     return () => window.removeEventListener('beforeinstallprompt', handler);
//   }, []);

//   const onClick = (evt) => {
//     evt.preventDefault();
//     if (!promptInstall) return;

//     promptInstall.prompt();
//     promptInstall.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         setSupportsPWA(false);
//       }
//     });
//   };

//   if (!supportsPWA || isDismissed) {
//     return null;
//   }

//   return (
//     <>
//       {/* Dimmed Background Overlay */}
//       <div className="pwa-backdrop-overlay" onClick={() => setIsDismissed(true)} />

//       {/* Centered Premium Modal Card */}
//       <div className="pwa-modal-wrapper">
//         <div className="pwa-modal-card">
//           {/* Top Brand Accent Bar */}
//           <div className="pwa-accent-top" />

//           {/* Close Button */}
//           <button
//             className="pwa-close-btn"
//             onClick={() => setIsDismissed(true)}
//             aria-label="Close modal"
//           >
//             <X size={16} />
//           </button>

//           {/* App Icon */}
//           <div className="pwa-brand-icon-wrap">
//             <Smartphone size={32} />
//           </div>

//           {/* Verification Badge */}
//           <div className="pwa-badge-pill">
//             <ShieldCheck size={12} /> Official Mobile App
//           </div>

//           {/* Title & Subtitle */}
//           <h3 className="pwa-modal-title">Install MKADDA</h3>
//           {/* <p className="pwa-modal-desc">
//             Enjoy instant battles, faster loading, and seamless secure gameplay directly from your home screen.
//           </p> */}

//           {/* Quick Features Row */}
//           <div className="pwa-features-row">
//             <div className="pwa-feature-item">
//               <Zap size={13} color="#0082cd" /> Fast Speed
//             </div>
//             <div className="pwa-dot-divider" />
//             <div className="pwa-feature-item">
//               <Sparkles size={13} color="#ffcd00" /> 100% Safe
//             </div>
//           </div>

//           {/* Main Action Install Button */}
//           <button className="pwa-install-btn" onClick={onClick}>
//             <span className="pwa-shimmer-line" />
//             <Download size={18} />
//             <span>INSTALL APP NOW</span>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Downloadbutton;


import React, { useEffect, useState } from "react";
import {
  Download,
  Smartphone,
  X,
  ShieldCheck,
  Zap,
  Sparkles,
} from "lucide-react";

const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isInstalling, setIsInstalling] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      setPromptInstall(event);
      setSupportsPWA(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () =>
      window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = async () => {
    if (!promptInstall || isInstalling) return;

    try {
      setIsInstalling(true);
      await promptInstall.prompt();

      const result = await promptInstall.userChoice;

      if (result.outcome === "accepted") {
        setSupportsPWA(false);
        setPromptInstall(null);
      }
    } catch (error) {
      console.error("PWA installation failed:", error);
    } finally {
      setIsInstalling(false);
    }
  };

  if (!supportsPWA || isDismissed) return null;

  const gold = "#e7c56b";

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      zIndex: 9998,
      background: "rgba(0,0,0,0.72)",
      backdropFilter: "blur(4px)",
    },
    wrapper: {
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 14,
      pointerEvents: "none",
    },
    card: {
      position: "relative",
      width: "100%",
      maxWidth: 320,
      boxSizing: "border-box",
      padding: "23px 19px 17px",
      overflow: "hidden",
      borderRadius: 19,
      textAlign: "center",
      color: "#fff",
      background:
        "radial-gradient(ellipse at top,rgba(220,180,65,.12),transparent 60%),linear-gradient(145deg,#191919,#090909 75%,#171207)",
      border: "1px solid rgba(231,197,107,.45)",
      boxShadow: "0 18px 55px rgba(0,0,0,.65)",
      pointerEvents: "auto",
      animation: "mkCompactEnter .25s ease-out",
    },
    accent: {
      position: "absolute",
      top: 0,
      left: "25%",
      width: "50%",
      height: 2,
      background: "linear-gradient(90deg,#a47a20,#fff0ad,#b68b29)",
      boxShadow: "0 0 12px rgba(231,197,107,.4)",
    },
    close: {
      position: "absolute",
      top: 9,
      right: 9,
      width: 27,
      height: 27,
      display: "grid",
      placeItems: "center",
      padding: 0,
      borderRadius: "50%",
      border: "1px solid #353535",
      background: "#202020",
      color: "#ddd",
      cursor: "pointer",
    },
    iconWrap: {
      width: 53,
      height: 53,
      margin: "0 auto 10px",
      display: "grid",
      placeItems: "center",
      borderRadius: 16,
      color: gold,
      background: "linear-gradient(145deg,#302711,#17130a)",
      border: "1px solid rgba(231,197,107,.4)",
      boxShadow: "inset 0 0 14px rgba(231,197,107,.06)",
    },
    badge: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 5,
      padding: "5px 9px",
      marginBottom: 9,
      borderRadius: 30,
      border: "1px solid rgba(231,197,107,.25)",
      background: "rgba(231,197,107,.07)",
      color: gold,
      fontSize: 9,
      fontWeight: 800,
      letterSpacing: 1,
    },
    title: {
      margin: "0 0 6px",
      fontSize: 20,
      lineHeight: 1.25,
      fontWeight: 900,
      letterSpacing: ".2px",
      color: gold,
      overflowWrap: "anywhere",
    },
    description: {
      margin: "0 auto 13px",
      maxWidth: 255,
      color: "#a5a5a5",
      fontSize: 11,
      lineHeight: 1.5,
    },
    features: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      marginBottom: 15,
    },
    feature: {
      display: "flex",
      alignItems: "center",
      gap: 5,
      color: "#ddd",
      fontSize: 10,
      fontWeight: 650,
    },
    divider: {
      width: 3,
      height: 3,
      borderRadius: "50%",
      background: "#97752b",
    },
    install: {
      width: "100%",
      minHeight: 43,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      padding: "11px 12px",
      borderRadius: 11,
      border: "1px solid #f0d98f",
      background: "linear-gradient(110deg,#b1872a,#f4d982,#c49a35)",
      color: "#181207",
      fontSize: 12,
      fontWeight: 900,
      letterSpacing: ".45px",
      boxShadow: "0 4px 15px rgba(205,163,55,.16)",
      cursor: isInstalling ? "wait" : "pointer",
      opacity: isInstalling ? 0.7 : 1,
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 5,
      marginTop: 11,
      color: "#777",
      fontSize: 9,
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes mkCompactEnter {
            from {
              opacity: 0;
              transform: translateY(10px) scale(.98);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          @media (max-width: 360px) {
            .mk-compact-card {
              max-width: 300px !important;
              padding: 21px 15px 15px !important;
            }
            .mk-compact-title {
              font-size: 18px !important;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .mk-compact-card {
              animation: none !important;
            }
          }
        `}
      </style>

      <div
        style={styles.overlay}
        onClick={() => setIsDismissed(true)}
        aria-hidden="true"
      />

      <div
        style={styles.wrapper}
        role="dialog"
        aria-modal="true"
        aria-labelledby="mk-compact-title"
      >
        <div
          className="mk-compact-card"
          style={styles.card}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={styles.accent} />

          <button
            type="button"
            style={styles.close}
            onClick={() => setIsDismissed(true)}
            aria-label="Close install popup"
          >
            <X size={15} />
          </button>

          <div style={styles.iconWrap}>
            <Smartphone size={28} strokeWidth={1.8} />
          </div>

          <div style={styles.badge}>
            <ShieldCheck size={11} />
            OFFICIAL MOBILE APP
          </div>

          <h3
            id="mk-compact-title"
            className="mk-compact-title"
            style={styles.title}
          >
            Install MKADDA
          </h3>

          <p style={styles.description}>
            Play faster with instant access from your home screen.
          </p>

          <div style={styles.features}>
            <div style={styles.feature}>
              <Zap size={13} color={gold} fill={gold} />
              Fast Access
            </div>

            <div style={styles.divider} />

            <div style={styles.feature}>
              <Sparkles size={13} color={gold} />
              Easy to Use
            </div>
          </div>

          <button
            type="button"
            style={styles.install}
            onClick={onClick}
            disabled={isInstalling}
          >
            <Download size={17} strokeWidth={2.4} />
            {isInstalling ? "OPENING..." : "INSTALL APP NOW"}
          </button>

          <div style={styles.footer}>
            <ShieldCheck size={11} color={gold} />
            Add directly to your device
          </div>
        </div>
      </div>
    </>
  );
};

export default Downloadbutton;
